import apiConfig from "constants/apiConfig";
import axiosClient from "utils/axiosClient"

export const fetchContentLibrary = async (agencyId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CONTENT_LIBRARY.url.replace('<agencyId>', agencyId), {params: payload});
    return response.data;
}